export default {
    addBusiness: 'Ajouter une entreprise',
    list: {
        title: 'Liste des entreprises',
        description: "Gérer vos annonces d'entreprises",
        noDataFound: 'Aucune entreprise trouvée',
        viewAnalytics: 'Voir les analyses',
        previous: 'Précédent',
        next: 'Suivant',
    },
    create: {
        title: 'Créer une entreprise',
        description: "Ajouter une nouvelle annonce d'entreprise",
        createBusiness: 'Créer une entreprise',
        form: {
            coverPhotos: {
                title: 'Photo de couverture',
                addMorePhotos: 'Ajouter plus de photos +',
                onSuccessDeletePhoto: {
                    title: 'Photo supprimée',
                    message: 'La photo a été supprimée avec succès.',
                },
                dropzone: {
                    title: 'Glissez-déposez vos images ici',
                    subtitle: 'ou cliquez pour sélectionner des fichiers',
                    supportedFileTypes: 'JPG, JPEG, PNG pris en charge',
                    dragAcceptTitle: 'Parfait ! Déposez vos images',
                    dragAcceptSubtitle: 'Ces fichiers sont prêts à être téléchargés',
                    dragRejectTitle: 'Type de fichier invalide',
                    dragRejectSubtitle: 'Veuillez déposer uniquement des fichiers image',
                    dragActiveTitle: 'Déposez vos images ici',
                    dragActiveSubtitle: 'Relâchez pour téléverser vos fichiers',
                    clearAll: 'Tout effacer',
                    upload: 'Téléverser',
                    selectedFiles_one: '{{count}} image sélectionnée',
                    selectedFiles_other: '{{count}} images sélectionnées',
                },
            },
            businessDetails: {
                title: "Détails de l'entreprise",
                name: 'Nom',
                email: 'Courriel',
                phone: 'Numéro de téléphone',
                businessAddress: 'Adresse',
                description: 'Description',
                selectACategory: 'Sélectionnez une catégorie',
                phoneNumber: 'Numéro de téléphone',
            },
            offers: {
                title: 'Offres',
                offer: 'Offre',
                description: 'Description',
                reward: 'Récompense',
                minFollowers: 'Nombre minimum de followers',
                requiredStoryCount: 'Nombre de story requises',
                addOffer: 'Ajouter une offre',
            },
            businessHours: {
                title: "Heures d'ouverture",
                monday: 'Lundi',
                tuesday: 'Mardi',
                wednesday: 'Mercredi',
                thursday: 'Jeudi',
                friday: 'Vendredi',
                saturday: 'Samedi',
                sunday: 'Dimanche',
                open: 'Ouvert',
                close: 'Fermé',
            },
            onSuccessApproval: {
                title: 'Entreprise Approuvée',
                message: "L'entreprise a été approuvée avec succès.",
            },
            onSuccessEditting: {
                title: 'Entreprise Modifiée',
                message: "L'entreprise a été modifiée avec succès.",
            },
        },
        formErrors: {
            name: 'Entrez le nom de votre entreprise',
            category: 'Choisissez au moins une catégorie',
            description: {
                en: 'Ajoutez une description en anglais d’au moins 5 caractères',
                fr: 'Ajoutez une description en français d’au moins 5 caractères',
            },
            phone: 'Entrez un numéro de téléphone',
            emailInvalid: 'Entrez un courriel valide, par exemple contact@votreentreprise.com',
            phoneInvalid: 'Entrez un numéro de téléphone valide, par exemple 514 555-5555',
            websiteInvalid: 'Entrez un site web valide, par exemple www.votreentreprise.com',
            coverPhotos: 'Ajoutez au moins une photo de votre entreprise',
            location: {
                lat: 'Choisissez votre adresse parmi les suggestions pour qu’elle soit localisée',
                lng: 'Choisissez votre adresse parmi les suggestions pour qu’elle soit localisée',
            },
            offers: {
                atLeastOne: 'Ajoutez au moins une offre',
                reward: 'Décrivez ce que reçoit l’influenceur, en anglais et en français',
                minFollowers: 'Indiquez un minimum d’abonnés d’au moins 1',
                requiredStoryCount: 'Demandez au moins une story ou un reel',
                category: 'Choisissez une catégorie pour cette offre',
            },
            businessHours: 'Activez au moins une journée où les influenceurs peuvent venir',
            owner: 'Cette entreprise doit avoir un propriétaire',
            place: 'Commencez à taper votre adresse et choisissez-la parmi les suggestions',
        },
        dropzone: {
            title: 'Glissez-déposez vos images ici',
            subtitle: 'ou cliquez pour sélectionner des fichiers',
            supportedFileTypes: 'JPG, JPEG, PNG pris en charge',
            dragAcceptTitle: 'Parfait ! Déposez vos images',
            dragAcceptSubtitle: 'Ces fichiers sont prêts à être téléchargés',
            dragRejectTitle: 'Type de fichier invalide',
            dragRejectSubtitle: 'Veuillez déposer uniquement des fichiers image',
            dragActiveTitle: 'Déposez vos images ici',
            dragActiveSubtitle: 'Relâchez pour téléverser vos fichiers',
            clearAll: 'Tout effacer',
            upload: 'Téléverser',
        },
    },
    details: {
        title: "Détails d'entreprise",
        description: "Afficher et gérer les détails de l'entreprise",
        unapprovedBusiness: {
            title: "Demandes d'approbation",
        },
        approvedBusiness: {
            title: 'Entreprises actives',
        },
    },
    approveBusiness: 'Approuver l’entreprise',
    approved: 'Approuvée',
    pendingApproval: "En attente d'approbation",
    analytics: {
        title: 'Analytique',
        pie: {
            accepted: 'Acceptées',
            rejected: 'Rejetées',
            canceled: 'Annulées',
            archived: 'Archivée',
            pending: 'En attente',
            title: "Vue d'ensemble des demandes",
            total: 'Demandes totales',
            influencers: 'Influenceurs',
            businesses: 'Entreprises',
            usersTitle: 'Données des utilisateurs',
        },
        table: {
            title: 'Réclamations sans réponse (en attente 5+ jours)',
            business: 'Entreprise',
            totalClaims: 'Demandes totales',
            unanswered: 'Non répondues',
            unansweredPercentage: '% non répondu',
        },
    },
};
